// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/user","layout":false,"id":"1"},"2":{"name":"login","path":"/user/login","parentId":"1","id":"2"},"3":{"name":"register","path":"/user/register","parentId":"1","id":"3"},"4":{"path":"/welcome","name":"welcome","icon":"smile","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/my/info","name":"my.info","icon":"user","parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"/my/application","name":"my.application","icon":"profile","parentId":"ant-design-pro-layout","id":"6"},"7":{"path":"/","redirect":"/welcome","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__user__login__index" */'@/pages/user/login/index.js')),
'3': React.lazy(() => import(/* webpackChunkName: "p__user__register__index" */'@/pages/user/register/index.js')),
'4': React.lazy(() => import(/* webpackChunkName: "p__expert__Welcome__index" */'@/pages/expert/Welcome/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "p__expert__MyInfo__index" */'@/pages/expert/MyInfo/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__expert__MyApplication__index" */'@/pages/expert/MyApplication/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.js')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/root/workspace/csida-rc_6PNv/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
